import React from "react";
import { Button } from "@mui/material";

const ACTButton = ({
  content,
  onClick,
  bgColor,
  textColor,
  hoverColor,
  hoverTextColor,
  border,
  hoverBorder,
  textLineHeight,
}) => {
  return (
    <Button
      sx={{
        backgroundColor: bgColor || "#000000",
        color: textColor || "#ffffff",
        fontSize: "1rem",
        fontWeight: "500",
        lineHeight: textLineHeight || "auto",
        width: "100%",
        margin: "0 !important",
        textTransform: "uppercase",
        "&:hover": {
          backgroundColor: hoverColor || "#cccccc",
          color: hoverTextColor || "#000000",
          border: hoverBorder || "#000000",
        },
        padding: "0.35rem 0.5rem",
        border: border || '0.1rem solid #000000', 
        borderRadius: "3rem",
      }}
      onClick={onClick}
    >
      {content}
    </Button>
  );
};

export default ACTButton;
